import { render, staticRenderFns } from "./goodsFilesDetail.vue?vue&type=template&id=14143f10&scoped=true"
import script from "./goodsFilesDetail.vue?vue&type=script&lang=js"
export * from "./goodsFilesDetail.vue?vue&type=script&lang=js"
import style0 from "./goodsFilesDetail.vue?vue&type=style&index=0&id=14143f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14143f10",
  null
  
)

export default component.exports